import { render } from "./Option_Item.vue?vue&type=template&id=050300eb&scoped=true"
import script from "./Option_Item.vue?vue&type=script&lang=js"
export * from "./Option_Item.vue?vue&type=script&lang=js"

import "./Option_Item.vue?vue&type=style&index=0&id=050300eb&lang=scss&scoped=true"

import exportComponent from "D:\\Work\\Sportips\\Nouveaux modules\\nm_sportips-inscriptions\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-050300eb"]])

export default __exports__